import { formatValue } from 'App/irrigation-scheduler/components/Grid/components/IrrigationZoneEmitterRows/components/_utils/formatValue'
import type { TRowData } from 'App/irrigation-scheduler/utils/store/types'
import { colors } from 'settings/colors'
import { icsTableStyles } from '../_utils/icsTableStyles'

const cellStyle = {
  ...icsTableStyles.bodyCell,
  padding: 6,
  fontSize: 12,
}

export const PlanningDataRow = ({ row, dates }: { row: TRowData; dates: string[] }) => {
  return (
    <>
      <td
        css={{
          ...cellStyle,
          fontSize: 12,
          fontWeight: 'bold',
          textAlign: 'left',
          backgroundColor: row.backgroundColor,
          color: row.color ?? colors.grey800,
        }}
      >
        {row.label}
      </td>
      {row.dailyValues.map((value, idx) => (
        <td
          key={dates[idx] ?? idx}
          css={{ ...cellStyle, backgroundColor: row.backgroundColor, color: row.color ?? colors.midnight }}
        >
          <span css={{ display: 'inline-block', minWidth: 40, textAlign: 'right' }}>
            {formatValue(value)}
          </span>
        </td>
      ))}
      <td
        css={{
          ...cellStyle,
          fontWeight: 'bold',
          backgroundColor: row.backgroundColor ?? colors.subtleBackground,
          color: row.color ?? colors.midnight,
        }}
      >
        <span css={{ display: 'inline-block', minWidth: 40, textAlign: 'right' }}>
          {formatValue(row.totalValue)}
        </span>
      </td>
    </>
  )
}
